// extracted by mini-css-extract-plugin
module.exports = {"headline":"story-headline-m__headline__1LzaJ","dark":"story-headline-m__dark__1wPld","light":"story-headline-m__light__3KbPt"};